export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.24-1134.13",
  commitId: "83ebaff9ec6792e9d54d8c6319d2c087f2a152ed",
  commitTime: "2026-06-24T11:34:13.000Z",
});
